import { get, post } from "../../helpers/utils/http-client";
import { ACCOUNTS_ENDPOINT } from '../../consts/api-endpoints';
import { signOutAndRedirectToLogin } from "../auth/auth-service";

export async function getMyAccount() {
    try {
        const { response, status } = await get(`${ACCOUNTS_ENDPOINT}/me`);
        if (status !== 200) {
            await signOutAndRedirectToLogin();
            return {};
        }
        return response;
    } catch (err) {
        console.debug('getMyAccount failed cause', err.message, err.code);
        await signOutAndRedirectToLogin();
        return {};
    }
}